import { cn } from './cn';

/** Inline loading spinner; inherits `currentColor` so it matches its context. */
export function Spinner({ className }: { className?: string }) {
  return (
    <svg
      role="status"
      aria-label="Loading"
      className={cn('animate-spin text-current', className)}
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
      />
      <span className="sr-only">Loading</span>
    </svg>
  );
}
